export default __webpack_public_path__ + "static/media/bannerImage5.c8daf79f.jpg";